// extracted by mini-css-extract-plugin
module.exports = {"cardOuter":"_3UXbj","contentWrap":"_1msk-","cardSubHeading":"A0PTF"};